import { getBffUrl, getMainInitTokenStorageKey, SESSION_KEYS } from "./shared/config";
import { createServiceClient } from "./shared/clientFactory";
export { tokenRequest } from "./shared/token";

const mainClient = createServiceClient({
  baseURL: getBffUrl(),
  tipo: "1",
  initTokenStorageKey: getMainInitTokenStorageKey(),
  awsAuthStorageKey: SESSION_KEYS.MAIN_AWS_AUTH_TOKEN,
});

export const {
  instance,
  postRequest,
  putRequest,
  getRequest,
  deleteRequest,
  downloadRequest,
  encodeBasicCredential,
} = mainClient;